import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { useTranslation } from 'react-i18next';

import OperatingHours from './OperatingHours';

export interface OperatingHoursDisplayComponentProps {
	operatingHours?: number | null;
	energyThroughput?: number | null;
	operatingHoursDate?: string | null;
}

export const OperatingHoursDisplayComponent = ({
	operatingHours,
	energyThroughput,
	operatingHoursDate,
}: OperatingHoursDisplayComponentProps): React.JSX.Element | null => {
	const hasOperatingHours = !!operatingHours && operatingHours > 0;
	const hasEnergyThroughput = !!energyThroughput && energyThroughput > 0;
	const hasHours = hasOperatingHours || hasEnergyThroughput;

	const { t } = useTranslation('common');

	if (!hasHours) {
		return null;
	}

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
			}}>
			{hasOperatingHours && (
				<>
					<OperatingHours fontSize="medium" />
					<Typography
						component={'span'}
						variant="subtitle2"
						sx={{
							opacity: 0.6,
							ml: 1,
							fontSize: 14,
						}}>
						{operatingHours}
					</Typography>
				</>
			)}

			{hasEnergyThroughput && (
				<>
					<Typography
						component={'span'}
						variant="body2"
						sx={{
							opacity: 0.6,
							fontSize: 14,
						}}>
						{t('mega-watt-hours')}
					</Typography>
					<Typography
						component={'span'}
						variant="subtitle2"
						sx={{
							opacity: 0.6,
							ml: 1,
							fontSize: 14,
						}}>
						{energyThroughput}
					</Typography>
				</>
			)}

			{operatingHoursDate && (
				<Typography
					component={'span'}
					variant="body2"
					sx={{
						opacity: 0.6,
						ml: 1,
						fontSize: 14,
					}}>
					{operatingHoursDate}
				</Typography>
			)}
		</Box>
	);
};
